"use client";

import { useQuery } from "@tanstack/react-query";
import { reviewKeys } from "@/features/reviews/shared/keys";
import type { CanReviewResult } from "@/features/reviews/shared/types";

export function useCanReview(productId: string, enabled = false) {
  return useQuery({
    queryKey: reviewKeys.canReview(productId),
    queryFn: async (): Promise<CanReviewResult> => {
      const params = new URLSearchParams();
      params.set("productId", productId);

      const response = await fetch(`/api/reviews/can-review?${params.toString()}`);

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.code || "FAILED_TO_CHECK");
      }

      return response.json();
    },
    enabled,
    staleTime: 30 * 1000, // 30 seconds
  });
}
